import { Revision } from "db/definitions";
import { batchAddRevisions } from "../graphql/mutations";
import { generateClient } from "aws-amplify/api";
import { recordSentry } from "utils/recordSentry";

async function batchCreateRevisions(revisions: Revision[]): Promise<boolean> {
	if (revisions.length > 0) {
		try {
			const client = generateClient({ authMode: "userPool" });
			await client.graphql({
				query: batchAddRevisions,
				variables: { revisions: revisions },
				authMode: "userPool",
			});
			return true;
		} catch (error) {
			recordSentry({ error });
		}
		return false;
	}
	return true;
}

export default batchCreateRevisions;
